<template>
  <div class="logo-div">
    <span
      :class="{ pgray: !nightMode, 'text-color': nightMode }"
      > 
      <span class="details-color">{ </span> 
        <span class="logo-div-name d-none d-md-inline">{{ name }} </span>
        <span class="logo-div-name d-inline d-md-none">CYonusg</span>
      <span class="details-color"> }</span> 
      <span class="d-none d-md-inline role-div-name"> = Software-engineer </span>
    </span>
    <span class="d-none d-md-inline logo-title-dot pblue">{{ dot }}</span>
  </div>
</template>

<script>
import info from "../../../info";

export default {
  name: "Logo",
  props: {
    nightMode: {
      type: Boolean,
    },
  },
  data() {
    return {
      name: info.logo_name,
      dot: ".",
    };
  },
};
</script>

<style scoped>
.logo-div:hover .logo-title-name {
  letter-spacing: 0px;
  transition: 0.5s all;
}

.logo-title-name {
  font-size: 35px;
  font-weight: 500;
  transition: 0.5s all;
}

.logo-title-dot {
  font-size: 30px;
  font-weight: 700;
}
</style>
